class CustomAvailability extends HTMLElement {
  constructor() {
    super();

    const tags = this.dataset.tags;
    const selectedState = document.documentElement.dataset.stateSelected;
    if (!tags || !selectedState) return;

    let markup = ``;

    if (selectedState == 'VIC' && tags.includes(selectedState)) {
      markup = `
        <span class="alert alert--note alert--circle alert--success">
          Available for pick up and delivery
        </span>
      `;
    }

    this.innerHTML = markup;
  }
}
if (!customElements.get('custom-availability')) {
  customElements.define('custom-availability', CustomAvailability);
}